(() => {
  'use strict';

  if (window.__SNS_CUSTOMER_MEDIA_V3__) {
    window.__SNS_CUSTOMER_MEDIA_V3__.init(document);
    return;
  }

  const ROOT = '[data-sns-customer-media]';
  const COLOR_MAP = {
    'black':'#111111','white':'#ffffff','red':'#e32636','blue':'#2f62d0','baby blue':'#9ed7f5',
    'navy':'#14213d','navy blue':'#14213d','fuchsia':'#e6007e','hot pink':'#ff2f92',
    'pink':'#f36fa8','purple':'#7a45b8','yellow':'#ffd82e','neon yellow':'#eaff00',
    'green':'#2e9e57','neon green':'#39ff14','orange':'#ff7a00','neon orange':'#ff5f00',
    'turquoise':'#25c7c7','beige':'#d9c3a5','brown':'#8b5e3c','grey':'#888888','gray':'#888888',
    'silver':'#c5c5c5','gold':'#d4af37','coral':'#ff6f61'
  };

  const esc = value => (window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&'));

  class CustomerMediaV3 {
    constructor(root) {
      this.root = root;
      this.id = root.dataset.snsCmId;
      this.handle = root.dataset.productHandle || '';
      this.zoomScale = Math.max(1.5, Number(root.dataset.zoomScale || 2));
      this.currency = root.dataset.currency || 'USD';
      this.mobileSwipe = root.dataset.mobileSwipe !== 'false';
      this.modalSwipe = root.dataset.modalSwipe !== 'false';
      this.saveCartImage = root.dataset.saveCartImage !== 'false';
      this.defaultVariantId = Number(root.dataset.defaultVariantId || 0) || null;
      this.afterAdd = root.dataset.afterAdd || 'cart';

      this.galleryIndex = 0;
      this.currentSlide = 0;
      this.visibleCount = 1;
      this.isZoomed = false;
      this.animating = false;
      this.zoomMoveArmed = false;
      this.lastZoomPointer = null;
      this.zoomUnlockAt = 0;
      this.mobileZoomMode = false;
      this.touchZoomPan = null;
      this.productData = null;
      this.selectedVariant = null;

      this.previewLocked = false;
      this.colorMap = {};
      this.colorCache = new Map();

      this.touchStart = null;
      this.modalTouchStart = null;
      this.panX = 0; this.panY = 0;
      this.panStartX = 0; this.panStartY = 0;
      this.pointerStartX = 0; this.pointerStartY = 0;

      this.onResize = this.onResize.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    q(name, scope=this.root) { return scope?.querySelector(`.ai-${name}-${this.id}`) || null; }
    qa(name, scope=this.root) { return Array.from(scope?.querySelectorAll(`.ai-${name}-${this.id}`) || []); }

    init() {
      if (!this.id || this.root.dataset.snsCmReady === '1') return;

      this.viewport = this.q('customer-media-viewport');
      this.track = this.q('customer-media-track');
      this.cards = this.qa('customer-media-thumbnail');
      this.originalOrder = [...this.cards];
      this.desktopPrev = this.root.querySelector(`.ai-customer-media-gallery-nav-${esc(this.id)}--prev`);
      this.desktopNext = this.root.querySelector(`.ai-customer-media-gallery-nav-${esc(this.id)}--next`);
      this.mobilePrev = this.root.querySelector(`.ai-customer-media-mobile-nav-${esc(this.id)}--prev`);
      this.mobileNext = this.root.querySelector(`.ai-customer-media-mobile-nav-${esc(this.id)}--next`);
      this.mobileCounter = this.q('customer-media-mobile-counter');

      this.modal = document.querySelector(`.ai-customer-media-modal-${esc(this.id)}`);
      this.modalImage = this.q('customer-media-modal-image', this.modal);
      this.modalCurrent = this.q('customer-media-modal-current', this.modal);
      this.baseSurface = this.q('customer-media-base-surface', this.modal);
      this.zoomSurface = this.q('customer-media-zoom-surface', this.modal);
      this.mobileZoomButton = this.q('customer-media-mobile-zoom-btn', this.modal);
      this.modalCounter = this.q('customer-media-modal-counter', this.modal);
      this.loader = this.modalImage?.querySelector('.ai-loader') || null;
      this.modalThumbs = this.q('customer-media-modal-thumbs', this.modal);

      if (!this.viewport || !this.track || !this.cards.length || !this.modal || !this.modalImage) {
        console.warn('[SNS Customer Looks V3.12.4] Missing required DOM', this.id);
        return;
      }

      this.readColorMap();
      this.prepareSwatches();
      this.setupGallery();
      this.setupModal();
      this.buildModalThumbs();
      this.setupVariants();
      this.setupLIPs();
      this.setupAddToCart();
      this.resetAddButton();

      this.updateGalleryMetrics(true);
      this.updateCounters();
      this.loadProductData();

      window.addEventListener('resize', this.onResize, {passive:true});
      document.addEventListener('keydown', this.onKeydown);

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.updateGalleryMetrics(false));
        this.ro.observe(this.viewport);
      }

      this.root.dataset.snsCmReady = '1';
      this.root.__snsCustomerMediaV3 = this;
    }

    readColorMap() {
      const el = document.querySelector(`script[data-sns-cm-color-map="${esc(this.id)}"]`);
      if (!el) return;
      try { this.colorMap = JSON.parse(el.textContent || '{}'); }
      catch(e) { console.warn('[SNS Customer Looks V3.12.4] color map JSON', e); }
    }

    setupGallery() {
      const movePrev = () => this.moveGallery(-1);
      const moveNext = () => this.moveGallery(1);

      this.desktopPrev?.addEventListener('click', movePrev);
      this.desktopNext?.addEventListener('click', moveNext);
      this.mobilePrev?.addEventListener('click', movePrev);
      this.mobileNext?.addEventListener('click', moveNext);

      this.cards.forEach((card, index) => {
        card.addEventListener('click', () => this.openModal(index));
      });

      if (this.mobileSwipe) {
        this.viewport.addEventListener('touchstart', e => {
          if (!this.isMobile()) return;
          const t = e.touches[0];
          this.touchStart = t ? {x:t.clientX,y:t.clientY} : null;
        }, {passive:true});

        this.viewport.addEventListener('touchend', e => {
          if (!this.isMobile() || !this.touchStart) return;
          const t = e.changedTouches[0];
          if (!t) return;
          const dx = t.clientX - this.touchStart.x;
          const dy = t.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.moveGallery(dx < 0 ? 1 : -1);
          }
        }, {passive:true});
      }
    }

    isMobile() { return window.matchMedia('(max-width: 989px)').matches; }

    onResize() {
      this.updateGalleryMetrics(false);
      if (this.modal?.classList.contains('active')) {
        requestAnimationFrame(() => {
          this.resetZoom();
          this.fitBaseImage();
        });
      }
    }

    restoreOriginalOrder() {
      if (!this.track || !this.originalOrder?.length) return;
      this.originalOrder.forEach(card => this.track.appendChild(card));
    }

    updateGalleryMetrics(reset=false) {
      if (!this.viewport || !this.track || this.animating) return;

      if (this.isMobile()) {
        this.restoreOriginalOrder();
        this.visibleCount = 1;
        this.root.classList.toggle('is-overflowing', this.cards.length > 1);

        const slideWidth = this.viewport.clientWidth;
        this.cards.forEach(card => {
          card.style.flex = `0 0 ${slideWidth}px`;
          card.style.width = `${slideWidth}px`;
          card.style.minWidth = `${slideWidth}px`;
          card.style.maxWidth = `${slideWidth}px`;
        });

        if (reset) this.galleryIndex = 0;
        this.galleryIndex = Math.max(0, Math.min(this.galleryIndex, this.cards.length - 1));

        this.track.style.transition = 'transform .30s cubic-bezier(.22,.61,.36,1)';
        this.track.style.transform = `translate3d(-${this.galleryIndex * slideWidth}px,0,0)`;
      } else {
        this.cards.forEach(card => {
          card.style.flex = '';
          card.style.width = '';
          card.style.minWidth = '';
          card.style.maxWidth = '';
        });

        this.galleryIndex = 0;
        this.track.style.transition = '';
        this.track.style.transform = 'translate3d(0,0,0)';

        const first = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const cardWidth = first?.getBoundingClientRect().width || 1;
        const viewportWidth = this.viewport.clientWidth;
        this.visibleCount = Math.max(1, Math.floor((viewportWidth + gap) / (cardWidth + gap)));

        this.root.classList.toggle('is-overflowing', this.cards.length > this.visibleCount);
      }

      this.updateGalleryButtons();
      this.updateCounters();
    }

    desktopPageStep() {
      if (this.visibleCount <= 1) return 1;
      return Math.max(1, Math.min(this.visibleCount - 1, this.cards.length - 1));
    }

    moveGallery(direction) {
      if (this.cards.length <= 1 || this.animating) return;

      if (this.isMobile()) {
        const max = this.cards.length - 1;
        this.galleryIndex += direction;
        if (this.galleryIndex < 0) this.galleryIndex = max;
        if (this.galleryIndex > max) this.galleryIndex = 0;
        this.updateGalleryMetrics(false);
        return;
      }

      if (!this.root.classList.contains('is-overflowing')) return;

      const count = this.desktopPageStep();
      const first = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const cardWidth = first?.getBoundingClientRect().width || 0;
      const distance = count * (cardWidth + gap);
      if (!distance) return;

      this.animating = true;

      const finish = () => {
        this.track.style.transition = 'none';
        this.track.style.transform = 'translate3d(0,0,0)';
        void this.track.offsetWidth;
        this.track.style.transition = '';
        this.animating = false;
        this.updateGalleryButtons();
      };

      if (direction > 0) {
        const moving = Array.from(this.track.children).slice(0, count);

        this.track.style.transition = 'transform .42s cubic-bezier(.22,.61,.36,1)';
        requestAnimationFrame(() => {
          this.track.style.transform = `translate3d(-${distance}px,0,0)`;
        });

        let finished = false;
        const done = () => {
          if (finished) return;
          finished = true;
          moving.forEach(node => this.track.appendChild(node));
          finish();
        };

        this.track.addEventListener('transitionend', done, {once:true});
        setTimeout(done, 650);
      } else {
        const children = Array.from(this.track.children);
        const moving = children.slice(-count);

        this.track.style.transition = 'none';
        for (let i = moving.length - 1; i >= 0; i--) this.track.prepend(moving[i]);

        this.track.style.transform = `translate3d(-${distance}px,0,0)`;
        void this.track.offsetWidth;

        this.track.style.transition = 'transform .42s cubic-bezier(.22,.61,.36,1)';
        requestAnimationFrame(() => {
          this.track.style.transform = 'translate3d(0,0,0)';
        });

        let finished = false;
        const done = () => {
          if (finished) return;
          finished = true;
          finish();
        };

        this.track.addEventListener('transitionend', done, {once:true});
        setTimeout(done, 650);
      }
    }

    updateGalleryButtons() {
      const disabled = this.cards.length <= 1 || (!this.isMobile() && !this.root.classList.contains('is-overflowing'));
      [this.desktopPrev,this.desktopNext,this.mobilePrev,this.mobileNext].forEach(btn => {
        if (btn) btn.disabled = disabled;
      });
    }

    updateCounters() {
      if (this.mobileCounter) this.mobileCounter.textContent = `${this.galleryIndex + 1} / ${this.cards.length}`;
      if (this.modalCounter) this.modalCounter.textContent = `${this.currentSlide + 1} / ${this.cards.length}`;
    }

    buildModalThumbs() {
      if (!this.modalThumbs) return;

      this.modalThumbs.innerHTML = '';

      this.originalOrder.forEach((card, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `ai-customer-media-modal-thumb-${this.id}`;
        btn.dataset.index = String(index);
        btn.setAttribute('aria-label', `Show customer photo ${index + 1}`);

        const source = card.querySelector('img, video');
        if (source?.tagName === 'IMG') {
          const img = document.createElement('img');
          img.src = source.currentSrc || source.src;
          img.alt = '';
          img.loading = 'lazy';
          btn.appendChild(img);
        } else if (source?.tagName === 'VIDEO') {
          const vid = document.createElement('video');
          vid.src = source.currentSrc || source.src;
          vid.muted = true;
          vid.playsInline = true;
          vid.preload = 'metadata';
          btn.appendChild(vid);
        }

        btn.addEventListener('click', () => {
          this.currentSlide = index;
          this.renderModalMedia();
          this.updateCounters();
          this.updateModalThumbs();
          this.resetZoom();
          this.preloadAdjacent();
        });

        this.modalThumbs.appendChild(btn);
      });

      this.updateModalThumbs();
    }

    updateModalThumbs() {
      if (!this.modalThumbs) return;

      const thumbs = Array.from(this.modalThumbs.children);
      thumbs.forEach((thumb, index) => {
        const active = index === this.currentSlide;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && this.modalThumbs) {
          // Horizontal centering ONLY. Do not use scrollIntoView here because it can
          // vertically scroll the whole popup and make the image/panel appear cut.
          const targetLeft = thumb.offsetLeft - (this.modalThumbs.clientWidth - thumb.offsetWidth) / 2;
          this.modalThumbs.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
        }
      });
    }

    setupModal() {
      const close = this.q('customer-media-modal-close', this.modal);
      const prev = this.modal.querySelector(`.ai-customer-media-modal-nav-${esc(this.id)}--prev`);
      const next = this.modal.querySelector(`.ai-customer-media-modal-nav-${esc(this.id)}--next`);

      close?.addEventListener('click', () => this.closeModal());
      prev?.addEventListener('click', () => this.changeModal(-1));
      next?.addEventListener('click', () => this.changeModal(1));
      this.modal.addEventListener('click', e => { if (e.target === this.modal) this.closeModal(); });

      // DESKTOP:
      // 1) popup always opens showing the COMPLETE base photo.
      // 2) the first mouse movement only records an origin point.
      // 3) zoom starts only after a deliberate movement from that origin.
      this.modalImage.addEventListener('mousemove', e => {
        if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        if (!this.modalCurrent || this.modalCurrent.tagName !== 'IMG') return;
        if (performance.now() < this.zoomUnlockAt) return;

        if (!this.zoomMoveArmed || !this.lastZoomPointer) {
          this.zoomMoveArmed = true;
          this.lastZoomPointer = { x:e.clientX, y:e.clientY };
          return;
        }

        if (!this.isZoomed) {
          const dx = e.clientX - this.lastZoomPointer.x;
          const dy = e.clientY - this.lastZoomPointer.y;
          const distance = Math.hypot(dx, dy);

          // Ignore tiny browser/layout mousemove events when the popup appears.
          if (distance < 14) return;
        }

        this.activateZoomSurface(e);
      });

      this.modalImage.addEventListener('mouseleave', () => {
        if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

        this.resetZoom();
        this.zoomMoveArmed = false;
        this.lastZoomPointer = null;
      });

      // MOBILE JOYSTICK ZOOM:
      // - The photo itself NEVER captures vertical scrolling.
      // - Zoom exists only while pressing/dragging the small side control.
      // - A short joystick movement maps to the full zoom travel.
      // - Releasing OR leaving the control resets the zoom immediately.
      const beginJoystickZoom = (e) => {
        if (!this.isMobile()) return;
        if (!this.modalCurrent || this.modalCurrent.tagName !== 'IMG') return;
        if (!this.mobileZoomButton || !this.zoomSurface) return;

        e.preventDefault();
        e.stopPropagation();

        const g = this.getContainedImageGeometry();
        if (!g) return;

        const zoomW = g.width * this.zoomScale;
        const zoomH = g.height * this.zoomScale;

        // Start perfectly centered.
        const minX = Math.min(0, g.box.width - zoomW);
        const minY = Math.min(0, g.box.height - zoomH);
        const centerX = minX / 2;
        const centerY = minY / 2;
        const maxX = 0;
        const maxY = 0;

        const src = this.modalCurrent.currentSrc || this.modalCurrent.src;
        this.zoomSurface.style.backgroundImage = `url("${src.replace(/"/g, '\\"')}")`;
        this.zoomSurface.style.backgroundSize = `${zoomW}px ${zoomH}px`;
        this.zoomSurface.style.backgroundPosition = `${centerX}px ${centerY}px`;
        this.zoomSurface.style.backgroundRepeat = 'no-repeat';

        this.isZoomed = true;
        this.mobileZoomMode = true;
        this.modalImage.classList.add('zoomed');
        this.mobileZoomButton.setAttribute('aria-pressed', 'true');

        const fullTravelX = Math.max(1, (maxX - minX) / 2);
        const fullTravelY = Math.max(1, (maxY - minY) / 2);

        this.touchZoomPan = {
          pointerId: e.pointerId,
          bgX: centerX,
          bgY: centerY,
          lastX: e.clientX,
          lastY: e.clientY,
          minX,
          minY,
          maxX,
          maxY,
          // ~20% slower than V3.12.3
          joystickRadius: 59,
          speedX: fullTravelX / 59,
          speedY: fullTravelY / 59
        };

        if (this.mobileZoomButton.setPointerCapture) {
          try { this.mobileZoomButton.setPointerCapture(e.pointerId); } catch(_) {}
        }
      };

      const moveJoystickZoom = (e) => {
        if (!this.mobileZoomMode || !this.isZoomed || !this.touchZoomPan) return;
        if (e.pointerId !== this.touchZoomPan.pointerId) return;

        e.preventDefault();
        e.stopPropagation();

        // Once the user has pressed the joystick, control remains active
        // anywhere on screen until pointerup/pointercancel.
        const dx = e.clientX - this.touchZoomPan.lastX;
        const dy = e.clientY - this.touchZoomPan.lastY;

        // Tiny dead-zone to reduce trembling/jumps.
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;

        // Latched / infinite control:
        // after pressing the joystick, motion is incremental and no longer
        // depends on re-entering the icon area, so returning over the icon
        // cannot cause a jump.
        let bgX = this.touchZoomPan.bgX + (dx * this.touchZoomPan.speedX);
        let bgY = this.touchZoomPan.bgY + (dy * this.touchZoomPan.speedY);

        bgX = Math.max(this.touchZoomPan.minX, Math.min(this.touchZoomPan.maxX, bgX));
        bgY = Math.max(this.touchZoomPan.minY, Math.min(this.touchZoomPan.maxY, bgY));

        this.touchZoomPan.bgX = bgX;
        this.touchZoomPan.bgY = bgY;
        this.touchZoomPan.lastX = e.clientX;
        this.touchZoomPan.lastY = e.clientY;

        this.zoomSurface.style.backgroundPosition = `${bgX}px ${bgY}px`;
      };

      const endJoystickZoom = (e) => {
        const pointerId = this.touchZoomPan?.pointerId;

        this.touchZoomPan = null;
        this.mobileZoomMode = false;
        this.mobileZoomButton?.setAttribute('aria-pressed', 'false');
        this.resetZoom();

        if (
          e &&
          pointerId != null &&
          this.mobileZoomButton?.releasePointerCapture
        ) {
          try { this.mobileZoomButton.releasePointerCapture(pointerId); } catch(_) {}
        }
      };

      this.mobileZoomButton?.addEventListener('pointerdown', beginJoystickZoom);
      this.mobileZoomButton?.addEventListener('pointermove', moveJoystickZoom);
      this.mobileZoomButton?.addEventListener('pointerup', endJoystickZoom);
      this.mobileZoomButton?.addEventListener('pointercancel', endJoystickZoom);

      // The photo remains ordinary mobile content:
      // vertical drag = scroll; horizontal swipe = next/previous image.
      this.modalImage.addEventListener('touchstart', e => {
        const t = e.touches[0];
        if (!t || this.mobileZoomMode) return;
        this.modalTouchStart = {x:t.clientX, y:t.clientY};
      }, {passive:true});

      this.modalImage.addEventListener('touchmove', () => {
        // Intentionally empty: browser owns normal vertical scrolling.
      }, {passive:true});

      this.modalImage.addEventListener('touchend', e => {
        if (!this.modalTouchStart || this.mobileZoomMode) return;

        const t = e.changedTouches[0];
        const dx = t ? t.clientX - this.modalTouchStart.x : 0;
        const dy = t ? t.clientY - this.modalTouchStart.y : 0;

        this.modalTouchStart = null;

        if (this.modalSwipe && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.changeModal(dx < 0 ? 1 : -1);
        }
      }, {passive:true});

      this.modalImage.addEventListener('touchcancel', () => {
        this.modalTouchStart = null;
      }, {passive:true});
    }

    openModal(index) {
      this.currentSlide = Math.max(0, Math.min(index, this.cards.length - 1));
      this.resetZoom();
      this.zoomMoveArmed = false;
      this.lastZoomPointer = null;
      this.zoomUnlockAt = performance.now() + 220;

      // Make the modal measurable BEFORE loading/fitting the media.
      this.modal.classList.add('active');
      this.modal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';

      // Always open at the true top. Previous thumbnail navigation must never
      // leave the popup or product column scrolled down.
      const modalContent = this.modal.querySelector(`.ai-customer-media-modal-content-${esc(this.id)}`);
      const productPanel = this.modal.querySelector(`.ai-customer-media-modal-product-${esc(this.id)}`);
      if (modalContent) modalContent.scrollTop = 0;
      if (productPanel) productPanel.scrollTop = 0;

      requestAnimationFrame(() => {
        if (modalContent) modalContent.scrollTop = 0;
        if (productPanel) productPanel.scrollTop = 0;
        this.renderModalMedia();
        this.updateCounters();
        this.updateModalThumbs();
        this.preloadAdjacent();
      });

      this.modal.querySelector('.ai-customer-media-modal-close-' + this.id)?.focus?.({preventScroll:true});
      clearTimeout(this.touchZoomTimer);
    }

    closeModal() {
      this.modal.classList.remove('active');
      this.modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      clearTimeout(this.touchZoomTimer);
      this.resetZoom();
      this.awaitFirstZoomMove = false;
      this.lastZoomPointer = null;
      if (this.modalCurrent?.tagName === 'VIDEO') this.modalCurrent.pause?.();
    }

    changeModal(direction) {
      if (!this.cards.length) return;
      this.currentSlide += direction;
      if (this.currentSlide < 0) this.currentSlide = this.cards.length - 1;
      if (this.currentSlide >= this.cards.length) this.currentSlide = 0;
      this.resetZoom();
      this.zoomMoveArmed = false;
      this.lastZoomPointer = null;
      this.zoomUnlockAt = performance.now() + 160;
      this.renderModalMedia();
      this.updateCounters();
      this.updateModalThumbs();
      this.preloadAdjacent();
    }

    renderModalMedia() {
      const card = this.cards[this.currentSlide];
      if (!card || !this.modalImage) return;

      this.resetZoom();

      const type = card.dataset.mediaType || 'image';
      const src = card.dataset.mediaSrc || '';
      const alt = card.dataset.alt || 'Customer media';

      this.modalImage.classList.remove('loaded');
      if (this.loader) this.loader.style.display = 'flex';

      if (this.baseSurface) {
        this.baseSurface.style.backgroundImage = '';
      }

      const old = this.modalCurrent;
      if (!old) return;

      if (type === 'video') {
        if (this.baseSurface) this.baseSurface.style.display = 'none';

        const el = document.createElement('video');
        el.className = `ai-customer-media-modal-current-${this.id}`;
        el.src = src;
        el.controls = true;
        el.playsInline = true;
        el.muted = true;
        el.loop = true;
        old.replaceWith(el);
        this.modalCurrent = el;

        const done = () => this.mediaLoaded();
        el.addEventListener('loadeddata', done, {once:true});
        el.addEventListener('error', done, {once:true});
        el.load();
      } else {
        const el = document.createElement('img');
        el.className = `ai-customer-media-modal-current-${this.id}`;
        el.src = src;
        el.alt = alt;
        old.replaceWith(el);
        this.modalCurrent = el;

        // Set the visible base surface immediately.
        if (this.baseSurface) {
          this.baseSurface.style.backgroundImage = `url("${src.replace(/"/g, '\\"')}")`;
          this.baseSurface.style.backgroundSize = 'contain';
          this.baseSurface.style.backgroundPosition = 'center center';
          this.baseSurface.style.backgroundRepeat = 'no-repeat';
        }

        if (el.complete) this.mediaLoaded();
        else {
          el.addEventListener('load', () => this.mediaLoaded(), {once:true});
          el.addEventListener('error', () => this.mediaLoaded(), {once:true});
        }
      }
    }

    mediaLoaded() {
      this.resetZoom();

      // The base photo is NOT the <img>; it is the contain background surface.
      // This avoids every width/height/intrinsic-size interaction that was cropping portraits.
      requestAnimationFrame(() => {
        this.fitBaseImage();

        requestAnimationFrame(() => {
          this.fitBaseImage();
          this.modalImage.classList.add('loaded');
          if (this.loader) this.loader.style.display = 'none';
        });
      });
    }

    fitBaseImage() {
      if (!this.modalImage || !this.modalCurrent) return false;
      if (this.modalCurrent.tagName !== 'IMG') return false;

      const nw = this.modalCurrent.naturalWidth || 0;
      const nh = this.modalCurrent.naturalHeight || 0;
      const boxW = this.modalImage.clientWidth || 0;
      const boxH = this.modalImage.clientHeight || 0;

      if (!nw || !nh || !boxW || !boxH) return false;

      // TRUE CONTAIN geometry used by the zoom math.
      const scale = Math.min(boxW / nw, boxH / nh);
      const displayW = Math.max(1, nw * scale);
      const displayH = Math.max(1, nh * scale);
      const left = (boxW - displayW) / 2;
      const top = (boxH - displayH) / 2;

      this.baseFit = {
        naturalWidth:nw,
        naturalHeight:nh,
        boxWidth:boxW,
        boxHeight:boxH,
        width:displayW,
        height:displayH,
        left,
        top,
        scale
      };

      if (this.baseSurface) {
        const src = this.modalCurrent.currentSrc || this.modalCurrent.src;
        this.baseSurface.style.backgroundImage = `url("${src.replace(/"/g, '\\"')}")`;
        this.baseSurface.style.backgroundSize = 'contain';
        this.baseSurface.style.backgroundPosition = 'center center';
        this.baseSurface.style.backgroundRepeat = 'no-repeat';
      }

      return true;
    }

    preloadAdjacent() {
      [-1,1].forEach(offset => {
        const idx = (this.currentSlide + offset + this.cards.length) % this.cards.length;
        const card = this.cards[idx];
        if (!card || card.dataset.mediaType === 'video') return;
        const src = card.dataset.mediaSrc;
        if (src) { const img = new Image(); img.src = src; }
      });
    }

    getContainedImageGeometry() {
      if (!this.modalImage || !this.modalCurrent || this.modalCurrent.tagName !== 'IMG') return null;

      const box = this.modalImage.getBoundingClientRect();
      const nw = this.modalCurrent.naturalWidth || 0;
      const nh = this.modalCurrent.naturalHeight || 0;

      if (!box.width || !box.height || !nw || !nh) return null;

      const scale = Math.min(box.width / nw, box.height / nh);
      const width = nw * scale;
      const height = nh * scale;
      const left = (box.width - width) / 2;
      const top = (box.height - height) / 2;

      return {box, width, height, left, top};
    }

    activateZoomSurface(point) {
      if (!this.zoomSurface || !this.modalCurrent || this.modalCurrent.tagName !== 'IMG') return;

      const g = this.getContainedImageGeometry();
      if (!g) return;

      const clientX = Number(point?.clientX);
      const clientY = Number(point?.clientY);
      if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) return;

      const localX = clientX - g.box.left;
      const localY = clientY - g.box.top;

      if (
        localX < g.left ||
        localX > g.left + g.width ||
        localY < g.top ||
        localY > g.top + g.height
      ) {
        this.resetZoom();
        return;
      }

      const nx = (localX - g.left) / g.width;
      const ny = (localY - g.top) / g.height;
      const zoomW = g.width * this.zoomScale;
      const zoomH = g.height * this.zoomScale;

      const bgX = localX - nx * zoomW;
      const bgY = localY - ny * zoomH;

      const src = this.modalCurrent.currentSrc || this.modalCurrent.src;
      this.zoomSurface.style.backgroundImage = `url("${src.replace(/"/g, '\\"')}")`;
      this.zoomSurface.style.backgroundSize = `${zoomW}px ${zoomH}px`;
      this.zoomSurface.style.backgroundPosition = `${bgX}px ${bgY}px`;
      this.zoomSurface.style.backgroundRepeat = 'no-repeat';

      this.isZoomed = true;
      this.modalImage.classList.add('zoomed');

      return {
        bgX,
        bgY,
        zoomW,
        zoomH,
        boxW:g.box.width,
        boxH:g.box.height
      };
    }

    resetZoom() {
      this.isZoomed = false;
      this.touchZoomPan = null;
      this.modalImage?.classList.remove('zoomed');

      if (this.zoomSurface) {
        this.zoomSurface.style.backgroundImage = '';
        this.zoomSurface.style.backgroundSize = '';
        this.zoomSurface.style.backgroundPosition = '';
      }

      // Base surface is untouched by zoom.
      if (this.modalCurrent?.tagName === 'IMG' && this.modal?.classList.contains('active')) {
        this.fitBaseImage();
      }
    }

    readColorMap() {
      const el = document.querySelector(`script[data-sns-cm-color-map="${esc(this.id)}"]`);
      if (!el) return;
      try { this.colorMap = JSON.parse(el.textContent || '{}'); } catch(e) {}
    }

    prepareSwatches() {
      const colorGroups = this.root.querySelectorAll(`.ai-customer-media-variant-values-${esc(this.id)}[data-type="color"]`);
      colorGroups.forEach(group => {
        group.querySelectorAll(`.ai-variant-pill-${esc(this.id)}`).forEach(btn => {
          const value = (btn.dataset.value || '').trim();
          let color = (btn.dataset.swatchColor || '').trim();
          const swatchImage = (btn.dataset.swatchImage || '').trim();

          if (!color) {
            const normalized = value.toLowerCase().replace(/\bsheer\b/g,'').trim();
            color = COLOR_MAP[normalized] || COLOR_MAP[value.toLowerCase()] || this.guessCssColor(normalized);
          }

          if (color) btn.style.setProperty('--sns-swatch-color',color);
          if (swatchImage) btn.style.setProperty('--sns-swatch-image',`url("${swatchImage.replace(/"/g,'\\"')}")`);
          if (value.toLowerCase().includes('sheer')) btn.dataset.sheer = 'true';
        });
      });
    }

    guessCssColor(name) {
      const test = document.createElement('span');
      test.style.color = '';
      test.style.color = name;
      return test.style.color ? name : '#d8d8d8';
    }

    variantGroups() {
      return Array.from(this.modal.querySelectorAll(`.ai-customer-media-variant-values-${esc(this.id)}`))
        .filter(g => !g.closest(`.ai-customer-media-lips-${esc(this.id)}`));
    }

    setupVariants() {
      this.variantGroups().forEach(group => {
        const isColor = group.dataset.type === 'color';
        group.querySelectorAll(`.ai-variant-pill-${esc(this.id)}`).forEach(btn => {
          btn.addEventListener('click',()=>this.selectVariant(btn,isColor,true));
          if (isColor) {
            btn.addEventListener('mouseenter',()=>{ if(!this.previewLocked)this.showColorPreview(btn); });
            btn.addEventListener('mouseleave',()=>{ if(!this.previewLocked)this.hideColorPreview(); });
          }
        });
      });

      this.previewBox = this.q('color-preview',this.modal);
      this.previewImg = this.previewBox?.querySelector('img') || null;
      this.previewClose = this.q('color-preview-close',this.modal);
      this.previewClose?.addEventListener('click',()=>{
        this.previewLocked=false;
        if(this.previewBox)this.previewBox.style.display='none';
        if(this.previewClose)this.previewClose.style.display='none';
      });

      this.updateVariantLabels();
    }

    selectVariant(btn,isColor,lockPreview) {
      const group = btn.parentElement;
      group.querySelectorAll(`.ai-variant-pill-${esc(this.id)}`).forEach(b=>b.classList.remove('selected'));
      btn.classList.add('selected');
      this.updateVariantLabels();

      if (this.productData) {
        const values = this.variantGroups().map(g => g.querySelector(`.ai-variant-pill-${esc(this.id)}.selected`)?.dataset.value || null);
        const candidate = this.productData.variants.find(v => v.options.every((opt,i)=>!values[i] || values[i]===opt));
        if (candidate) {
          this.selectedVariant=candidate;
          this.updateProductInfo();
        }
      }

      if (isColor) {
        this.showColorPreview(btn);
        if (lockPreview) {
          this.previewLocked=true;
          if(this.previewClose)this.previewClose.style.display='flex';
        }
      }
    }

    updateVariantLabels() {
      this.variantGroups().forEach(group => {
        const wrap = group.closest(`.ai-customer-media-variant-option-${esc(this.id)}`);
        const label = wrap?.querySelector('[data-selected-value]');
        const selected = group.querySelector(`.ai-variant-pill-${esc(this.id)}.selected`);
        if (label && selected) label.textContent = selected.dataset.value || selected.textContent.trim();
      });
    }

    async loadProductData() {
      if (this.productData) return this.productData;
      try {
        let handle=this.handle;
        if(!handle){
          const parts=location.pathname.split('/').filter(Boolean);
          const i=parts.indexOf('products');
          if(i>=0)handle=parts[i+1]||'';
        }
        if(!handle)return;
        const root=(window.Shopify?.routes?.root)||'/';
        const res=await fetch(`${root}products/${encodeURIComponent(handle)}.js`,{credentials:'same-origin'});
        if(!res.ok)return;
        this.productData=await res.json();
        this.selectedVariant=this.productData.variants.find(v=>v.available)||this.productData.variants[0]||null;
        this.applyInitialVariant();
        this.updateProductInfo();
        return this.productData;
      } catch(e) {
        console.warn('[SNS Customer Looks V3.6] product data',e);
        return null;
      }
    }

    applyInitialVariant() {
      const options=this.selectedVariant?.options||[];
      this.variantGroups().forEach((group,i)=>{
        if(!options[i])return;
        group.querySelectorAll(`.ai-variant-pill-${esc(this.id)}`).forEach(btn=>btn.classList.toggle('selected',btn.dataset.value===options[i]));
      });
      this.updateVariantLabels();
    }

    updateProductInfo() {
      if(!this.selectedVariant)return;
      const price=this.q('customer-media-current-price',this.modal);
      const compare=this.q('customer-media-compare-price',this.modal);
      try{
        const fmt=new Intl.NumberFormat('en-US',{style:'currency',currency:this.currency});
        if(price)price.textContent=fmt.format(this.selectedVariant.price/100);
        if(compare){
          if((this.selectedVariant.compare_at_price||0)>this.selectedVariant.price){
            compare.textContent=fmt.format(this.selectedVariant.compare_at_price/100);
            compare.style.display='inline';
          } else compare.style.display='none';
        }
      }catch(e){}
    }

    async showColorPreview(btn) {
      if(!this.previewBox||!this.previewImg)return;
      const key=(btn.dataset.colorKey||'').trim();
      if(!key)return;

      let url=btn.dataset.colorSrc||this.colorCache.get(key)||this.colorMap?.[key]?.files_jpg||null;
      if(!url)return;
      this.colorCache.set(key,url);
      btn.dataset.colorSrc=url;
      this.previewImg.src=url;
      this.previewBox.style.display='block';
    }

    hideColorPreview() {
      if(this.previewLocked)return;
      if(this.previewBox)this.previewBox.style.display='none';
      if(this.previewClose)this.previewClose.style.display='none';
    }

    setupLIPs() {
      const wrap=this.q('customer-media-lips',this.modal);
      if(!wrap)return;
      wrap.querySelectorAll('.sns-lip-field').forEach(field=>this.buildLip(field));
    }

    splitOptions(raw) {
      const txt=(raw||'').trim();
      if(!txt)return[];
      if(txt.startsWith('[')&&txt.endsWith(']')){
        try{const arr=JSON.parse(txt);if(Array.isArray(arr))return arr.map(v=>String(v).trim());}catch(e){}
      }
      return (txt.includes('|')?txt.split('|'):txt.split(',')).map(v=>String(v).trim().replace(/^["']+|["']+$/g,'')).filter(Boolean);
    }

    buildLip(field) {
      const ui=field.querySelector('.sns-lip-ui');
      if(!ui)return;
      const label=field.dataset.labelDefault||field.dataset.prop||'Option';
      const options=this.splitOptions(field.dataset.options||'');
      if(!options.length){field.style.display='none';return;}

      ui.innerHTML='';
      const hidden=document.createElement('input');
      hidden.type='hidden'; hidden.name=`properties[${label}]`;
      ui.appendChild(hidden);

      options.forEach((value,i)=>{
        const btn=document.createElement('button');
        btn.type='button';
        btn.className=`ai-variant-pill-${this.id}${i===0?' selected':''}`;
        btn.dataset.value=value;
        btn.textContent=value;
        btn.addEventListener('click',()=>{
          ui.querySelectorAll(`.ai-variant-pill-${esc(this.id)}`).forEach(b=>b.classList.remove('selected'));
          btn.classList.add('selected');
          hidden.value=value;
        });
        ui.appendChild(btn);
        if(i===0)hidden.value=value;
      });
    }

    collectLipProperties() {
      const props={};
      const wrap=this.q('customer-media-lips',this.modal);
      wrap?.querySelectorAll('input[type="hidden"][name^="properties["]').forEach(inp=>{
        const m=inp.name.match(/^properties\[(.*)\]$/);
        if(m?.[1]&&inp.value)props[m[1]]=inp.value;
      });
      return props;
    }

    setupAddToCart() {
      this.addButton=this.q('customer-media-add-to-cart',this.modal);
      this.addButton?.addEventListener('click',()=>this.addToCart());
    }

    selectedMediaProperty() {
      const card=this.cards[this.currentSlide];
      if(!card)return null;
      const image=(card.dataset.cartImage||'').trim();
      if(!image)return null;
      return {
        image,
        index:String(this.currentSlide+1),
        total:String(this.cards.length)
      };
    }

    resetAddButton() {
      if (!this.addButton) return;
      this.addButton.disabled = false;
      this.addButton.classList.remove('is-loading', 'is-added');
      this.addButton.setAttribute('aria-busy', 'false');
    }

    selectedOptionValues() {
      return this.variantGroups().map(group => {
        const selected = group.querySelector(`.ai-variant-pill-${esc(this.id)}.selected`);
        return selected?.dataset.value || null;
      });
    }

    resolveSelectedVariant() {
      if (!this.productData?.variants?.length) return this.selectedVariant;

      const values = this.selectedOptionValues();
      const exact = this.productData.variants.find(v =>
        v.options.every((option, index) => !values[index] || values[index] === option)
      );

      if (exact) this.selectedVariant = exact;
      return this.selectedVariant;
    }

    async ensureVariantForCart() {
      if (!this.productData) await this.loadProductData();
      const resolved = this.resolveSelectedVariant();
      if (resolved?.id) return Number(resolved.id);
      if (this.defaultVariantId) return Number(this.defaultVariantId);
      return null;
    }

    async addToCart() {
      if (!this.addButton || this.addButton.disabled) return;

      this.addButton.disabled = true;
      this.addButton.classList.remove('is-added');
      this.addButton.classList.add('is-loading');
      this.addButton.setAttribute('aria-busy', 'true');

      try {
        const variantId = await this.ensureVariantForCart();
        if (!variantId) throw new Error('No variant selected');

        const properties = this.collectLipProperties();

        if (this.saveCartImage) {
          const media = this.selectedMediaProperty();
          if (media) {
            properties._sns_customer_media_image = media.image;
            properties._sns_customer_media_index = media.index;
            properties._sns_customer_media_total = media.total;
          }
        }

        const root = (window.Shopify?.routes?.root) || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST',
          credentials:'same-origin',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({
            id:variantId,
            quantity:1,
            properties
          })
        });

        if (!response.ok) {
          const detail = await response.text().catch(()=>'');
          throw new Error(`Cart add ${response.status}: ${detail}`);
        }

        const added = await response.json();

        sessionStorage.setItem('snsCustomerMediaLastAdded', JSON.stringify({
          variantId: added.variant_id || added.id || variantId,
          image: properties._sns_customer_media_image || ''
        }));

        this.addButton.classList.remove('is-loading');
        this.addButton.classList.add('is-added');
        this.addButton.setAttribute('aria-busy', 'false');

        if (this.afterAdd === 'stay') {
          setTimeout(() => this.resetAddButton(), 700);
        } else {
          /* Reset first so BFCache/back navigation can never restore a blocked button. */
          setTimeout(() => {
            this.resetAddButton();
            window.location.assign(`${root}cart`);
          }, 260);
        }
      } catch (error) {
        console.error('[SNS Customer Looks V3.6] Add to cart failed', error);
        this.resetAddButton();
      }
    }

    onKeydown(e) {
      if(!this.modal?.classList.contains('active'))return;
      if(e.key==='Escape')this.closeModal();
      if(e.key==='ArrowLeft')this.changeModal(-1);
      if(e.key==='ArrowRight')this.changeModal(1);
    }

    destroy() {
      window.removeEventListener('resize',this.onResize);
      document.removeEventListener('keydown',this.onKeydown);
      this.ro?.disconnect?.();
      this.root.dataset.snsCmReady='0';
    }
  }

  function init(scope=document){
    const roots=[];
    if(scope.matches?.(ROOT))roots.push(scope);
    scope.querySelectorAll?.(ROOT).forEach(r=>roots.push(r));
    roots.forEach(root=>{
      if(root.dataset.snsCmReady==='1')return;
      try{new CustomerMediaV3(root).init();}
      catch(e){console.error('[SNS Customer Looks V3.12.4] init',e);}
    });
  }

  function destroy(scope){
    const roots=[];
    if(scope?.matches?.(ROOT))roots.push(scope);
    scope?.querySelectorAll?.(ROOT).forEach(r=>roots.push(r));
    roots.forEach(r=>r.__snsCustomerMediaV3?.destroy?.());
  }

  window.__SNS_CUSTOMER_MEDIA_V3__={init,destroy};

  window.addEventListener('pageshow', () => {
    document.querySelectorAll(ROOT).forEach(root => {
      root.__snsCustomerMediaV3?.resetAddButton?.();
    });
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);

  document.addEventListener('shopify:section:load',e=>init(e.target||document));
  document.addEventListener('shopify:block:select',e=>init(e.target||document));
  document.addEventListener('shopify:section:unload',e=>destroy(e.target));
})();